import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { catchError, lastValueFrom, Observable } from 'rxjs';

import { BasedataService } from '../shared/basedata.service';

import { ConfigService } from '@docma-mm-core/config/config.service';
import {Project} from '@docma-mm-core/project/project';
import { BpPin } from '../../bp-common/models/bp-pin';


@Injectable()
export class PinService extends BasedataService {


  constructor(private http: HttpClient, configService: ConfigService) {
    super(configService);
  }


  // get bp-pins by project
  public async getProjectPins(project: Project): Promise<BpPin[]> {
    const url = this.getFullUrl(`/projects/${project.MyDocmaUid}/coordinates`);
    const pins = await lastValueFrom(this.http.get<BpPin[]>(url, { headers: this.getHeaders() }));
    return pins;
  }



}
